export const generatedSourcePromotionLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-source-promotion-ledger",
  "operatingRule": "Registered sources are not model-ready evidence. Only reviewed intake reports that match the current source ingestion ledger may promote source payloads into business or science model records.",
  "sourceIngestionLedgerHash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
  "sourceWorkOrderCount": 33,
  "p0WorkOrderCount": 17,
  "reportCount": 1,
  "validReportCount": 1,
  "invalidReportCount": 0,
  "validationCount": 17,
  "submittedArtifactCount": 17,
  "promotedCount": 17,
  "blockedValidationCount": 0,
  "promotedSourceIds": [
    "cad-api",
    "dymos",
    "esa-psa",
    "gmat",
    "horizons-api",
    "horizons-mercury-2024",
    "iau-sofa",
    "jaxa-darts",
    "mpc",
    "nasa-mercury",
    "nist-codata",
    "openmdao",
    "orekit",
    "pds",
    "sbdb-api",
    "spice-gf",
    "tudat"
  ],
  "promotedWorkOrderIds": [
    "source-ingest-cad-api",
    "source-ingest-dymos",
    "source-ingest-esa-psa",
    "source-ingest-gmat",
    "source-ingest-horizons-api",
    "source-ingest-horizons-mercury-2024",
    "source-ingest-iau-sofa",
    "source-ingest-jaxa-darts",
    "source-ingest-mpc",
    "source-ingest-nasa-mercury",
    "source-ingest-nist-codata",
    "source-ingest-openmdao",
    "source-ingest-orekit",
    "source-ingest-pds",
    "source-ingest-sbdb-api",
    "source-ingest-spice-gf",
    "source-ingest-tudat"
  ],
  "promotedDomainCounts": {
    "ephemeris-and-astronomy": 7,
    "small-body-and-resource-evidence": 5,
    "trajectory-and-optimization": 5
  },
  "p0PromotionGapCount": 0,
  "promotionAllowed": true,
  "promotionState": "source-promotion-ready-for-review",
  "blockers": [],
  "reportSummaries": [
    {
      "sourcePath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "valid": true,
      "submittedArtifactCount": 17,
      "promotedCount": 17,
      "blockedCount": 0,
      "blockers": []
    }
  ],
  "p0PromotionGaps": [],
  "validations": [
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "horizons-api-reviewed-snapshot-source-payload",
      "sourceId": "horizons-api",
      "workOrderId": "source-ingest-horizons-api",
      "sourceTitle": "JPL Horizons API",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-3d82a242050d563135819fae24f8c59f833e228d20d4e5b4247bd1fe5f888bde",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-b749070bca453f6b0a33dc0482aff0f3fa8d0a8edd3a5cc64f3355c976cff94c"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "sbdb-api-reviewed-snapshot-source-payload",
      "sourceId": "sbdb-api",
      "workOrderId": "source-ingest-sbdb-api",
      "sourceTitle": "JPL Small-Body Database API",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-b20036c25e48229424603756715e7cefc11876aaa906c04b8acfd04f6c3ead39",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-9a7eaf7c43c51b3aad60e163388fa00193e43c69393abd9899475f9d1c848419"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "cad-api-reviewed-snapshot-source-payload",
      "sourceId": "cad-api",
      "workOrderId": "source-ingest-cad-api",
      "sourceTitle": "SBDB Close Approach Data API",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-6e624f6ed923aca6988924ba23d94c82ac713176d8df0b08f850e61f5789c7b4",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-383c85c048380428db83522c46343feac1a7c12dc2254b5313bf0185636b64be"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "nist-codata-reviewed-snapshot-source-payload",
      "sourceId": "nist-codata",
      "workOrderId": "source-ingest-nist-codata",
      "sourceTitle": "2022 CODATA Fundamental Physical Constants",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-3085d778695b4a312cb558e0f615e015862e4142e759eb690271bbf0500048e2",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-e5c91dcd6b740cf16e80caa6e1e4c0de60df8a4402c02143222ffe868d551aaa"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "spice-gf-reviewed-snapshot-source-payload",
      "sourceId": "spice-gf",
      "workOrderId": "source-ingest-spice-gf",
      "sourceTitle": "SPICE Geometry Finder",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-da3df60c90dd1d63bf9782965741833587959078921338de3fedbb5ab9c779f5",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-08118aec43fe1a527bc5b36f055e34a6e8ee8c5d7eb7093bb1b5754bdd12b2e8"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "orekit-reviewed-snapshot-source-payload",
      "sourceId": "orekit",
      "workOrderId": "source-ingest-orekit",
      "sourceTitle": "Orekit",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-ca896e1fcecafc2c5deccd3624347a0682c92c2243f2954faa104b0d03bc5d97",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-152d79efa64ddb3d8e133dc21c49c84e58501cbb62c58b8efc3f3eba93460f05"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "gmat-reviewed-snapshot-source-payload",
      "sourceId": "gmat",
      "workOrderId": "source-ingest-gmat",
      "sourceTitle": "General Mission Analysis Tool",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-d64756e74a6b8320ce3731e075806e910da653a008895a5ffb680e2fa9b142df",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-3c157a1a531afe4eeeaa2a18e9a04ef9b7af8040fe416515b45c6b0dc8aef84b"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "openmdao-reviewed-snapshot-source-payload",
      "sourceId": "openmdao",
      "workOrderId": "source-ingest-openmdao",
      "sourceTitle": "OpenMDAO",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-14777f0b2900cdf299aa16872d4bd977dd18d86309c68957491be467eab0d19b",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-b3ac536824be872100923f9a267a9e4e6f70ab8c164ac9dc07e9972d7082f2c5"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "dymos-reviewed-snapshot-source-payload",
      "sourceId": "dymos",
      "workOrderId": "source-ingest-dymos",
      "sourceTitle": "Dymos",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-334d266d6ca7ab5230ac4dbc566e4b8fc4b067264f1a4d2eb97ae58f8198d41a",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-36b3e87f27c4b110c7a7def214e14dea1bd4e395b307ace57c19ac77328cbbc8"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "tudat-reviewed-snapshot-source-payload",
      "sourceId": "tudat",
      "workOrderId": "source-ingest-tudat",
      "sourceTitle": "Tudat Space / TudatPy",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-e30d4c9118d4e24946d9eb8c8b0b8c49bf6ae880fb493291ef7f1c36b75e4e2f",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-cf95f68c41970b3333162e7b49806fff4ef21b5dbd3d0ea415e1f4388b096ca1"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "iau-sofa-reviewed-snapshot-source-payload",
      "sourceId": "iau-sofa",
      "workOrderId": "source-ingest-iau-sofa",
      "sourceTitle": "Standards of Fundamental Astronomy",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-e3fad753e92d74d55d640d4d8a9893ba96090acf581e8426d86010f418497bdd",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-1e95bb2584063c4ca1fcbbda2fb72d0020bec9a2c776e05d97e3d1f93ced03cc"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "horizons-mercury-2024-reviewed-snapshot-source-payload",
      "sourceId": "horizons-mercury-2024",
      "workOrderId": "source-ingest-horizons-mercury-2024",
      "sourceTitle": "JPL Horizons Mercury Physical Data",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-476714ef250d4f1bf97b4257d62b7f8533e4eeae98a26f5ba7d31468ab338189",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-b13d3c7d38d01dfbe56d9c9cd590889fb8bf9ca386a83a3a7caaffc715932065"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "pds-reviewed-snapshot-source-payload",
      "sourceId": "pds",
      "workOrderId": "source-ingest-pds",
      "sourceTitle": "Planetary Data System",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-43fb158c4921815fa14522d0cc8b2d465b3e3981474c98312838734e105bc948",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-9bc1dd93b1088f84c191678d70e67d0939b0f486d2fbbff8d0c63597d0f76003"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "mpc-reviewed-snapshot-source-payload",
      "sourceId": "mpc",
      "workOrderId": "source-ingest-mpc",
      "sourceTitle": "Minor Planet Center Data",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-c8c12ccc275cbdd182cd2e3dd9a1311ae685d5d71b18a9e81e3f9b4e83d73c68",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-c9bd13defe95f6cdb1b7f76e1a74a02335b2f0d5a111899042e169cb33ef37ea"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "esa-psa-reviewed-snapshot-source-payload",
      "sourceId": "esa-psa",
      "workOrderId": "source-ingest-esa-psa",
      "sourceTitle": "ESA Planetary Science Archive",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-cef0926a4919db5bf06f967307dfe4ff872dff714e7a8706d44175860ff7b441",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-de8dc70b9f3120e90e916db3c984e84d4b8a1c96f86ca88adc5b9c27eaca8ad9"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "jaxa-darts-reviewed-snapshot-source-payload",
      "sourceId": "jaxa-darts",
      "workOrderId": "source-ingest-jaxa-darts",
      "sourceTitle": "DARTS Space Science Data Archive",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-91a72e40488e15a4c6a136aef21683a367a86c9fcdc2cb93983ba2e8028c8e00",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-495ff06ae31f41ebbebf87e23b532290bdf61cded83b66a548c226eb81512ba2"
    },
    {
      "reportPath": "evidence/source-intake-reports/reviewed-snapshot-source-intake-report.json",
      "reportHash": "sha256-a2a8ff110a8fec0b0646ef45d7b06608cbd7cefa5e1eb26203b56b5e5e8add96",
      "artifactId": "nasa-mercury-reviewed-snapshot-source-payload",
      "sourceId": "nasa-mercury",
      "workOrderId": "source-ingest-nasa-mercury",
      "sourceTitle": "Mercury Facts",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "validationHash": "sha256-8fdeae75955677693dc2171fe8edac37bb296563569e5934ad21e38bbd3de11e",
      "blockers": [],
      "nextAction": "Reviewed source payload may be promoted into model-ready records.",
      "promotionRecordHash": "sha256-06f00eb71e4f67302adcb0b595fccc5b91471a6d80214edf8cfb7a8b93e29b46"
    }
  ],
  "nextAction": "Review promoted source payloads against claims and model artifacts before customer use.",
  "ledgerHash": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4"
}
;
